<script lang="ts">
    import type DataProvider from '../services/data.provider'
    import { cancelReservation } from '../api/reservation.api'

    export let dataProvider: DataProvider

    let submitted = false
    let error = false
    let processing = false

    const cancel = async () => {
        try {
            error = false
            processing = true
            await cancelReservation({ hash: dataProvider.hash })
            submitted = true
        } catch (e) {
            error = true
        } finally {
            processing = false
        }
    }
</script>

<div class="bno-container bno-container--centered">
    <div class="bno-container__content">
        {#if submitted}
            <h2>Hotovo!</h2>
            <p>Vaše rezervace byla úspěšně zrušena.</p>
        {:else}
            <h2>Zrušení rezervace na úřad</h2>
            {#if error}
                <div class="bno-alert-light bno-alert-light--error">
                    <span class="bno-icon bno-icon--info"></span>
                    Rezervaci se nepodařilo zrušit, zkuste to, prosím, znovu.
                </div>
            {/if}
            <button disabled="{processing}"
                    on:click={() => cancel()}
                    class="bno-button bno-button--primary">
                {#if processing}
                    Počkejte, prosím...
                {:else}
                    Zrušit rezervaci
                {/if}
            </button>
        {/if}
    </div>
</div>
